import styled, { css } from 'styled-components';

const RadioGroupContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    ${({ horizontal }) =>
        horizontal === 'true' &&
        css`
            flex-direction: row;

            & label {
                flex: 1;
            }
        `};

    @media (max-width: 600px) {
        flex-direction: column;
    }
`;

const RadioButtonContainer = styled.label`
    display: flex;
    align-items: center;
    padding: 10px;
    margin: 5px 0;
    border: 2px solid ${(props) => (props.checked ? '#6a1b9a' : '#cccccc')};
    border-radius: 5px;
    cursor: pointer;
    gap: 10px;

    &:hover {
        border-color: #6a1b9a;
    }

    & img {
        width: 40px;
        height: 40px;
    }
`;

const HiddenRadioButton = styled.input.attrs({ type: 'radio' })`
    display: none;
`;

const CustomRadioButton = styled.div`
    min-height: 20px;
    min-width: 20px;
    border: 2px solid #6a1b9a;
    border-radius: 50%;
    margin-right: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:after {
        content: '';
        height: 12px;
        width: 12px;
        background-color: ${(props) =>
            props.checked ? '#6a1b9a' : 'transparent'};
        border-radius: 50%;
    }
`;

const RadioLabel = styled.span`
    font-size: 14px;
    color: ${(props) => (props.checked ? '#6a1b9a' : '#000000')};
    display: flex;
    align-items: center;
    gap: 10px;
`;

const RadioGroup = ({ options, value, onChange, horizontal = false }) => {
    return (
        <RadioGroupContainer horizontal={horizontal.toString()}>
            {options.map((option) => (
                <RadioButtonContainer
                    key={option.value}
                    checked={value === option.value}
                >
                    <HiddenRadioButton
                        checked={value === option.value}
                        onChange={() => onChange(option.value)}
                    />
                    <CustomRadioButton checked={value === option.value} />
                    <RadioLabel checked={value === option.value}>
                        {option.image ? option.image : ''}
                        {option.label}
                    </RadioLabel>
                </RadioButtonContainer>
            ))}
        </RadioGroupContainer>
    );
};

export default RadioGroup;
